import React, { Component } from 'react'
import VideoCarousel from '../VideoCaoursel'

export default class HobbyInfo extends Component {
  render() {
    return (
      <div>
        <VideoCarousel />
      </div>
    )
  }
}
